import { Toast } from '@leverege/ui-elements'

const eOptions = { 
  timeOut : 0
}
const wOptions = { 
  timeOut : 2000,
}

const sOptions = { 
  timeOut : 2000
}
export function requestWarn( title, ex ) {
  return requestError( title, ex, true )
}

export function requestError( title, ex, warning ) {
  console.log( 'ERROR:', title, ex )
  return function( dispatch, getState ) {
    const method = warning ? 'warn' : 'error'
    const res = ex.response;
    if ( res ) {
      // ex.status ignored for now
      const msg = ( ex.body && ex.body.message ) || ex.message || ex.statusText;
      Toast[method]( [ title, msg ], warning ? wOptions : eOptions )
    } else {
      Toast[method]( [ title, ex.message ], warning ? wOptions : eOptions )
    }
  }
}
export function error( title, message, code ) {
  return function( dispatch, getState ) {
    Toast.error( [ title, typeof message === 'string' ? message : JSON.stringify( message ) ], eOptions )
  };
}

export function warn( title, message, code ) {
  return function( dispatch, getState ) {
    Toast.warn( [ title, typeof message === 'string' ? message : JSON.stringify( message ) ], wOptions )
  };
}

export function success( title, message, code ) {
  return function( dispatch, getState ) {
    if ( message ) {
      Toast.success( [ title, typeof message === 'string' ? message : JSON.stringify( message ) ], sOptions )
    } else {
      Toast.success( [ 'Success', title ], sOptions )
    }
  };
}

module.exports = {
  error, success, requestError, warn, requestWarn
}
